<template>
  <img
    v-if="imageSrc"
    class="kk-option-item-icon kk-option-item-icon__image"
    :class="{
      'kk-option-item-icon__image--disabled': isDisabled,
    }"
    :src="imageSrc"
    :alt="imageAlt"
  />
  <KkIcon
    v-else-if="iconName"
    class="kk-option-item-icon kk-option-item-icon__icon"
    :class="{
      'kk-option-item-icon__icon--disabled': isDisabled,
    }"
    :name="iconName"
    :size="iconSize"
  />
</template>

<script>
import KkIcon from '../../KkIcon';

export default {
  name: 'KkOptionItemIcon',
  components: {
    KkIcon,
  },
  props: {
    iconName: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
